import { Component } from '@angular/core';

@Component({
  templateUrl: './account-settings.page.html',
})

/**
 * Account settings page
 */
export class AccountSettingsPage {}
